import { InjectionToken, EventEmitter } from '@angular/core';

export const LUMILOGIN_URL = new InjectionToken<string>('LUMILOGIN_URL')
export const LUMILOGIN_REALM = new InjectionToken<string>('LUMILOGIN_REALM')
export const LUMILOGIN_CLIENTID = new InjectionToken<string>('LUMILOGIN_CLIENTID')
export const LUMILOGIN_SECRET = new InjectionToken<string>('LUMILOGIN_SECRET')
export const APPLICATION_NAME = new InjectionToken<string>('APPLICATION_NAME')
export const THEME_CONFIG = new InjectionToken<any>('THEME_CONFIG')
export const URL_API_LUMILOGIN = new InjectionToken<any>('URL_API_LUMILOGIN')
export const SHOW_SEARCH_BAR = new InjectionToken<boolean>('SHOW_SEARCH_BAR') 
export const SHOW_LANG_SELECTOR = new InjectionToken<boolean>('SHOW_LANG_SELECTOR') 
export const DOC_URL = new InjectionToken<string>('DOC_URL') 
export const SHOW_HELP = new InjectionToken<boolean>('SHOW_HELP') 
export const SHOW_CGU = new InjectionToken<boolean>('SHOW_CGU') 
